require("./settings.js");
require("./handicaps.js");
require("./calculations/locks.js");
require("./card_groups.js");
require("./overrides.js");
require("./drop_ins/init.js");
require("./auto_configurations/shotgun.js");
require("./auto_configurations/tee_times.js");
